export default __webpack_public_path__ + "static/media/testimonial-img-09.9cf3bda2.jpg";